const React = require('react');
const Card = require('@andes/card');
const Button = require('@andes/button');
const { Work, WorkRebranding } = require('./image');
const { ButtonText } = Button;
const { getEventTracker } = require('../../../../../utils/event-tracker');
const Tracker = getEventTracker();
const { OneSteps, OneStepsRE } = require('./imageMobile');
const { isYellowBlueLightBrand } = require('../../../../../utils/isYellowBlueLightBrand');

const banner = ({ i18n, isMobile, lang, brand }) => {
  const sendToMelidata = (data) => {
    Tracker.melidata.send('/developers/click_banner', {
      banner: data,
    }, {
      autoDocsRefInfo: true,
    });
  };

  const WorkImage = () => {
    if (isMobile) {
      return isYellowBlueLightBrand(brand) ? <OneStepsRE /> : <OneSteps />;
    }
    return isYellowBlueLightBrand(brand) ? <WorkRebranding /> : <Work />;
  };

  return (
    <div className={`banner-card-container banner-card-${brand}`}>
      <Card
        color="green"
        shadow="flat"
        className={`banner-card banner-card-no-shadow-${brand}`}
  >
        <div className={`banner-card-content banner-card-background-banner-${brand}`}>
          <div className="banner-card-content-text">
            <h1 className="banner-card-content-title" data-brand={brand}>{ i18n.gettext('¿Dudas para comenzar a integrar?')}
            </h1>
            <p className="banner-card-content-description" data-brand={brand}>{isMobile ? i18n.gettext('Consulta la documentación para quienes recién están comenzando una integración.')
              : i18n.gettext('Consulta nuestra documentación pensada para quien recién empieza una experiencia de integración con Mercado Pago.')}
            </p>
            <Button href={`/developers/${lang}/docs/getting-started`} onClick={() => { Tracker.send('mpdevelopers/documentation/click_banner', 'getstarted'); sendToMelidata('getstarted'); }} srLabel={i18n.gettext('Ir a Primeros pasos')}>
              <ButtonText>{i18n.gettext('Ir a Primeros pasos')}</ButtonText>
            </Button>
          </div>
          <div className="banner-card-content-svg">
            <WorkImage />
          </div>
        </div>
      </Card>
    </div>
  );
};

module.exports = banner;
